// Shared fund sub-route layout + subnav (16.d.4.5a).
// Wraps the extracted /fund/:fundId/{settings,accounts,accruals,activity}
// sub-routes (16.d.4.1–.4) under one layout that renders a persistent
// fund-scoped subnav + an <Outlet/>, so the operator can move between
// sub-sections without round-tripping the /fund landing. The subnav reuses
// the `.nav-link` + data-active styling (the active-tab underline) but in an
// inline-flex container — NOT `.nav-links`, which is display:none on mobile.
//
// FundSubnav is exported so the /fund landing can render it too (16.d.4.5b),
// giving a consistent subnav across the landing + every sub-route.
import { Link, Outlet, useLocation, useParams } from 'react-router-dom';

export function FundSubnav({ fundId }: { fundId: string }) {
  const location = useLocation();
  const isActive = (path: string) => location.pathname === path;
  const items = [
    { label: 'Overview', path: '/fund' },
    { label: 'Accounts', path: `/fund/${fundId}/accounts` },
    { label: 'Accruals', path: `/fund/${fundId}/accruals` },
    { label: 'Holdings', path: `/fund/${fundId}/holdings` },
    { label: 'Activity', path: `/fund/${fundId}/activity` },
    { label: 'Statements', path: `/fund/${fundId}/statements` },
    { label: 'Settings', path: `/fund/${fundId}/settings` },
  ];
  return (
    <nav style={{
      display: 'flex', alignItems: 'center', gap: 28, flexWrap: 'wrap',
      borderBottom: 'var(--hairline)',
      paddingBottom: 10, marginBottom: 24,
    }}>
      {items.map(it => (
        <Link key={it.path} to={it.path} className="nav-link" data-active={isActive(it.path) ? '1' : '0'}>
          {it.label}
        </Link>
      ))}
    </nav>
  );
}

export default function FundLayout() {
  const { fundId } = useParams<{ fundId: string }>();
  if (!fundId) return null;
  return (
    <div className="view container">
      <FundSubnav fundId={fundId} />
      <Outlet />
    </div>
  );
}
